export const environment = {
  production: true,
  dominio: "https://api.multientregapanama.com/api/",
  dominio2: "https://admin.multientregapanama.com/api/",
}
